import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import lccRatings from "../../../../src/data/articles/cube-prospective-the-lost-caverns-of-ixalan-commander/lcc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  lccRatings,
  ProspectiveIntro,
  React
};